(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').factory('RelatorioVistaAbertaService', RelatorioVistaAbertaService);

  function RelatorioVistaAbertaService($http, ngsalConfig) {

    var service = {
      retornaRelatorioVistaAbertaCorregedoria: retornaRelatorioVistaAbertaCorregedoria,
    };

    return service;


    function retornaRelatorioVistaAbertaCorregedoria(filtroRelatorio) {

      var promise = $http.post("/mgp-corregedoria/api/" + ngsalConfig.apiVersion + "/relatorio/vistaAberta/corregedoria",filtroRelatorio).then(function (response) {
          return response.data;
      });

      return promise;
    }

  }

})();
